import { render } from "./PasiveFinancialView.vue?vue&type=template&id=9ba35834&ts=true"
import script from "./PasiveFinancialView.vue?vue&type=script&lang=ts"
export * from "./PasiveFinancialView.vue?vue&type=script&lang=ts"

import "./PasiveFinancialView.vue?vue&type=style&index=0&id=9ba35834&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__